import { observable, action } from 'mobx';
import { makeApi, URLS } from 'Utils/apiUtil';
import userDetail from 'Stores/userDetail';
import * as CONSTANTS from 'Utils/constants';

const { PERSONALIED_ONBOARDING_FLOWS } = CONSTANTS;
const { INITIAL_GUIDE_FLOW } = PERSONALIED_ONBOARDING_FLOWS;

let cancelCompanyNameCall = null;
class PersonalisedOnboardingState {
  @observable isPersonalisedOnboardingFlow = null;

  @observable onboardingCurrentStep = 0;

  @observable isOnboardingGuideFlow = false;

  @action
  setIsOnboardingGuideFlow = value => {
    this.isOnboardingGuideFlow = value;
  };

  @action
  setOnboardingCurrentStep = value => {
    this.onboardingCurrentStep = value;
  };

  @action
  setIsPersonalisedOnboardingFlow = value => {
    this.isPersonalisedOnboardingFlow = value;
  };

  @action
  clearOnboardingFlow = () => {
    if (this.isOnboardingGuideFlow) {
      this.onboardingCurrentStep = 0;
      this.setIsPersonalisedOnboardingFlow(INITIAL_GUIDE_FLOW);
    } else {
      this.isPersonalisedOnboardingFlow = null;
      this.onboardingCurrentStep = 0;
    }
  };

  getCompanyNameSuggestion = async inputVal => {
    const config = {
      url: URLS.companyNameWithDomain + userDetail.featureFlags.EU_CONTACTS,
      method: 'POST',
      data: {
        q: inputVal,
      },
    };

    if (cancelCompanyNameCall !== null) {
      cancelCompanyNameCall('cancel');
      cancelCompanyNameCall = null;
    }
    const companyNameCancelCallback = value => {
      cancelCompanyNameCall = value;
    };
    if (inputVal !== '')
      try {
        return await makeApi(config, false, companyNameCancelCallback);
      } catch (e) {
        console.error('get company name suggestion failed', e);
      }
    return {};
  };
}

const personalisedOnboardingState = new PersonalisedOnboardingState();

export { personalisedOnboardingState };
export default personalisedOnboardingState;
